(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => {
      setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
    }).observe(drawer, { attributes: true, attributeFilter: ['open', 'class'], subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
